import React, { Component } from 'react';
import '../App.css';
import {Link} from 'react-router-dom';

export default class AllBlog extends Component {
  constructor(props){
    super(props);
    this.state = {
    };
  }
  
  render() {
    let blog_list = this.props.app_state.blogs;
    let xml_list = [];
    //blog_list = [].concat(blog_list, blog_list, blog_list, blog_list, blog_list, blog_list)
    blog_list.forEach((this_blog)=>{
      xml_list.push(
        <div className="col-md-6 col-xl-4">
          <Link to={'/blog/'+this_blog.id}>
            <div className="all_blog_item">
              <h4>{this_blog.title}</h4>
              <img src={(this_blog.images||[{}])[0].url} />
            </div>
          </Link>
        </div>
      );
    });
    
    if (xml_list.length === 0) {
      xml_list = <h3 className="text-muted" 
                      style={{'width': '100%', 'margin': '200px auto'}}>
                   &nbsp;&nbsp;&nbsp;Loading...
                 </h3>;
    }
    
    return (
      [<h1>For the Love of People</h1>,
      <p style={{'padding': '10px 20px', 'maxWidth': '730px', 'margin': '0px auto'}}>
        These are stories of people who were able to put their pasts behind them and push towards their future. These are here to motivate you and persuade you that the best is yet to come.</p>,
      <hr/>,
      <div id="allblog_div" className="row">
        {xml_list}
      </div>]
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AllBlog.js